// Star.ts
//
// Star defines data structures related to stars.

import ActionResult from 'app/src/engine/action-results/ActionResult';
import CollectStarActionResult from 'app/src/engine/action-results/CollectStarActionResult';

export type StarLocation = {
	row: number;
	col: number;
};

export default class Star {
	public collected = false;

	private _location: StarLocation;
	get location(): StarLocation {
		return this._location;
	}

	constructor(location: StarLocation, collected = false) {
		this._location = location;
		this.collected = collected;
	}

	public clone(): Star {
		return new Star(this._location, this.collected);
	}

	public getActionResultsForCollection(): ActionResult[] {
		return [new CollectStarActionResult(this)];
	}
}
